import {
  CommonTrackingConfig,
  getCustomClickTrackValues,
  mapTrackingProperties,
} from '../../../modules/utils/trackingHelper';

export const resolveWalletEmbeddedTracking = (
  tracking?: CommonTrackingConfig,
  linkType: 'internal' | 'external' = 'internal'
) => {
  const trackingProperties = mapTrackingProperties(tracking);
  return {
    trackingProperties,
    customClickTrackValue: getCustomClickTrackValues(trackingProperties, linkType),
  };
};
